// extracted by mini-css-extract-plugin
export var linkText = "_pm-0";